import '@castleio/castle-js/dist/castle.browser.js';
Castle.configure({ pk: import.meta.env.VITE_CASTLE_PUBLISHABLE_KEY });
